const StaffSection = () => {
  const staffMembers = [
    {
      id: 1,
      name: '岡山 太郎',
      role: '代表取締役・管理者',
      image: 'https://public.readdy.ai/ai/img_res/e72f7e4b0fa188b0ae40b25f2c9e726b.jpg',
      description: '福祉業界で20年以上の経験を持ち、利用者様一人ひとりの可能性を最大限に引き出すことを使命としています。',
    },
    {
      id: 2,
      name: '山田 花子',
      role: 'サービス管理責任者',
      image: 'https://readdy.ai/api/search-image?query=Professional%20Japanese%20female%20service%20manager%20in%20her%2040s%20wearing%20smart%20casual%20clothing%2C%20gentle%20caring%20smile%20showing%20empathy%20and%20professionalism%2C%20standing%20in%20contemporary%20office%20setting%2C%20confident%20yet%20approachable%20expression%2C%20warm%20personality%20radiating%20through%20kind%20eyes%2C%20soft%20natural%20lighting%2C%20portrait%20photography%2C%20suitable%20for%20employment%20support%20coordinator%20role&width=600&height=600&seq=staff002&orientation=squarish',
      description: '利用者様の小さな変化も見逃さず、きめ細やかな支援計画の作成と実施を心がけています。',
    },
    {
      id: 3,
      name: '佐藤 健一',
      role: '職業指導員',
      image: 'https://static.readdy.ai/image/2333ec8ce0f23b8d6e87acea74053a0e/df018802552c7e69500a1f02fa6a8a87.png',
      description: '企業での実務経験を活かし、実践的な職業訓練プログラムを提供しています。就職後も継続的にサポートします。',
    },
  ];

  return (
    <section className="py-16 sm:py-20 lg:py-24 bg-bg-beige">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Section Header */}
        <div className="text-center mb-12 lg:mb-16">
          <p className="text-primary text-sm font-medium tracking-wider mb-3">（スタッフ紹介）</p>
          <h2 className="font-serif text-3xl sm:text-4xl lg:text-5xl font-bold text-text-dark">
            経験豊富な<strong>スタッフ</strong>が<br className="sm:hidden" />あなたをサポート
          </h2>
        </div>

        {/* Staff Grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8 lg:gap-10">
          {staffMembers.map((staff) => (
            <div
              key={staff.id}
              className="bg-white rounded-2xl shadow-lg overflow-hidden hover:shadow-xl transition-shadow"
            >
              {/* Profile Image */}
              <div className="relative w-full h-80">
                <img
                  src={staff.image}
                  alt={staff.name}
                  className="w-full h-full object-cover object-top"
                />
              </div>

              {/* Content */}
              <div className="p-6 space-y-3">
                <p className="text-text-medium text-sm">{staff.role}</p>
                <h3 className="text-xl font-bold text-text-dark text-center">{staff.name}</h3>
                <p className="text-text-medium text-sm leading-relaxed">{staff.description}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default StaffSection;
